import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const AccessFullIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <g transform="matrix(2.5454545,0,0,2.6666667,-2.5454545,-4)">
        <path d="M 23,12 20.56,9.21 20.9,5.52 17.29,4.7 15.4,1.5 12,2.96 8.6,1.5 6.71,4.69 3.1,5.5 3.44,9.2 1,12 l 2.44,2.79 -0.34,3.7 3.61,0.82 1.89,3.19 3.4,-1.47 3.4,1.46 1.89,-3.19 3.61,-0.82 -0.34,-3.69 z m -12.91,4.72 -3.8,-3.81 1.48,-1.48 2.32,2.33 5.85,-5.87 1.48,1.48 z" />
      </g>
    </SvgIcon>
  );
};

export default AccessFullIcon;
